import { useMemo } from "react";
import { useAtomValue } from "jotai";
import { selectedOrganisationAtom } from "@/atoms";
import { useOrgChannels } from "@lib/api-hooks/useOrgChannels";

/**
 * Returns a color override map for custom org channels.
 * Keys are normalized channel slugs (lowercase, no dashes/underscores/spaces).
 * Pass this as the second argument to `mapChannelToColor` so custom colors take precedence.
 */
export function useChannelColorMap(): Record<string, string> {
  const organisationId = useAtomValue(selectedOrganisationAtom) ?? "";
  const { data: orgChannels } = useOrgChannels(organisationId, {
    enabled: !!organisationId,
  });

  return useMemo(() => {
    const map: Record<string, string> = {};
    orgChannels?.forEach((ch) => {
      if (ch.color) {
        const key = ch.channel.toLowerCase().replace(/[-_\s]/g, "");
        map[key] = ch.color;
      }
    });
    return map;
  }, [orgChannels]);
}
